import React from 'react';
import Navbar from '../components/Internal-nav';  
import CabinetCard from '../components/cabinet-card';
import ProductData from '../data/cabinetdata.json';
import ContactBanner from '../components/contact-banner';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';

function Cabinets() {
  const cabinetsData = ProductData.Cabinets;
  const description = "Browse our extensive collection of premium kitchen and bathroom cabinets. From traditional to modern styles, find the perfect cabinets for your home renovation project.";
  const keywords = "kitchen cabinets, bathroom cabinets, custom cabinets, stock cabinets, Fort Wayne, Indiana, home improvement";

  return (
    <div className='App'>
      <SEO 
        title="Kitchen & Bathroom Cabinets"
        description={description}
        keywords={keywords}
        canonicalUrl="https://bcsupply.com/cabinets"
        ogImage="/assets/example-cabinet-banner.jpg"
      />
      <StructuredData 
        type="CollectionPage"
        name="BC Supply Cabinets Collection"
        description={description}
      />
      <header>
        <Navbar />
      </header>
      <div>
        <div className='inner-banner' style={{ backgroundImage: "url(../assets/example-cabinet-banner.jpg)"}}>
          <div className='banner-content'>
            <h1>Explore our Cabinet Options</h1>
          </div>
        </div>
        <div className='cabinet-list'>
          {cabinetsData ? 
            Object.keys(cabinetsData).map((key, i) => (
              <CabinetCard key={i} data={cabinetsData[key]}></CabinetCard>
            ))
            : 'loading'
          }
        </div>
        <ContactBanner></ContactBanner>
      </div>
    </div>
  );
}

export default Cabinets;
